import { Core, Decorative } from "@faire/design-tokens";
import { ContactUsButton } from "@faire/help-center-self-serve/components/ContactUsButton";
import { SelfServeSource } from "@faire/help-center-self-serve/consts";
import { ChatBubble } from "@faire/web--source/slate/icons/foundation/ChatBubble";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";

interface IProps {
  isFooter?: boolean;
}

export const ContactUsSideBanner: React.FC<IProps> = ({ isFooter }) => {
  const { isMobile } = useViewport();

  return (
    <Wrapper $isFooter={isFooter}>
      {isMobile ? (
        <ChatBubbleWrapper>
          <ChatBubble fontSize="22px" />
        </ChatBubbleWrapper>
      ) : null}
      <Typography variant="pageHeaderSerifRegular">
        <StrictLocalMsg
          defaultMessage="Need more help?"
          description={{
            img: "https://cdn.faire.com/fastly/947085add527e99dedbfe39cf9bdbaee84ddc2a01df34759bc1694ef04c44aa4.png",
          }}
        />
      </Typography>
      <Spacer height="2x" />
      <Typography variant="paragraphSansRegular">
        <StrictLocalMsg
          defaultMessage="Share more about your issue, and get in touch with our support team."
          description={{
            text: "Message about what to do if more help is needed.",
            img: "https://cdn.faire.com/fastly/3e55217625248fa1388f8246c70c4bd380b57a17dc3847db3d3312f1874c5561.png",
          }}
        />
      </Typography>
      <Spacer height="2x" />
      <FullWidthContactUsButton
        source={
          isFooter
            ? SelfServeSource.CONTACT_US_FOOTER_BANNER
            : SelfServeSource.CONTACT_US_SIDE_BANNER
        }
        variant={!isMobile && !isFooter ? "secondary" : "primary"}
      />
    </Wrapper>
  );
};

const Wrapper = styled(Column).attrs({ align: "flex-start" })<{
  $isFooter?: boolean;
}>`
  ${({ $isFooter }) => !$isFooter && `border: 1px solid ${Core.border.muted};`}
  padding: ${getSpacing("4x", "3x")};
  background-color: ${Core.surface.inverse};
  ${responsiveMediaQueries.mobile} {
    background-color: ${Decorative.tint.orange};
  }
`;

const FullWidthContactUsButton = styled(ContactUsButton)`
  width: 100%;
`;

const ChatBubbleWrapper = styled(Row)`
  padding: ${getSpacing("3x")};
  border-radius: 50%;
  border: 1px solid ${Core.surface.inverse};
  background-color: ${Core.surface.inverse};
  margin-bottom: ${getSpacing("1x")};
`;
